import React, { useState } from "react";

const Modal = ({ show, onClose, images, currentIndex, mode }) => {
  const [modal_currentIndex, modal_setCurrentIndex] = useState(currentIndex);
  if (!show) {
    return null;
  }

  const modal_nextSlide = () => {
    modal_setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const modal_prevSlide = () => {
    modal_setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };
  const handleBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  return (
    <div className="modal" onClick={handleBackgroundClick}>
      <div className="modal-content">
        <span className="close" onClick={onClose}>
          &times;
        </span>
        <div className="carousel-container">
          <div
            className="image-wrapper"
            style={{ transform: `translateX(-${modal_currentIndex * 100}%)` }}
          >
            {images.map((image, index) => {
              const lastItem = image.imageName.split("/").pop();
              return (
                <img
                  key={index}
                  src={
                    mode === "online"
                      ? image.path
                      : require(`../../assets/images/houses/${lastItem}`)
                  }
                  alt={`Slide ${index}`}
                  className="carousel-image"
                />
              );
            })}
          </div>

          {images.length > 1 ? (
            <>
              <div className="arrow left" onClick={modal_prevSlide}>
                &#10094;
              </div>
              <div className="arrow right" onClick={modal_nextSlide}>
                &#10095;
              </div>
            </>
          ) : (
            <div></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
